module.exports = __webpack_public_path__ + "assets/img/copy.60586a30.svg";